import { Button, Result } from "antd";
import React from "react";
import { Link } from "react-router-dom";

export default function FourOFour({ ...props }) {
  return (
    <Result
      status="404"
      title="Aradığınız sayfayı bulamadık."
      subTitle="Ulaşmak istediğiniz sayfa kaldırılmış ya da adresi yanlış yazmış olabilirsiniz. Sistem Yöneticinize danışınız."
      extra={
        <Button type="primary">
          <Link to="/panel">Panel</Link>
        </Button>
      }
    />
  );
}
